import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IStoreDataV3, Store } from '@df/catalog/store/store';
import { UiComponent } from '@df/ui/ui.component';
import { PageStoreFinderStoreStatusComponent } from '../store-status/page-store-finder-store-status.component';

@Component({
    selector: 'page-store-finder-store',
    templateUrl: 'page-store-finder-store.html',
    imports: [PageStoreFinderStoreStatusComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageStoreFinderStoreComponent extends UiComponent {
    /**
     * Store
     */
    @Input()
    store?: Store<IStoreDataV3>;
}
